import React, { Fragment } from 'react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { navigate } from 'gatsby';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { Bars3Icon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import axios from 'axios';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function AdminNavbar({ onToggleSidebar }) {
  const { user, setUser } = useAuthContext();

  const logoutSubmit = async (e) => {
    try {
      e.preventDefault();
      
      await axios.post('/api/logout');
      
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_name');
      setUser(null);
      navigate("/");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Disclosure as="nav" className="top-0 z-50 fixed w-full h-[var(--admin-navbar-height)] border-gray-700/50 border-b bg-gray-900 bg-opacity-95 backdrop-blur-sm">
      {() => (
        <div className="h-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-full">
            {/* Left: Brand + mobile toggle */}
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={onToggleSidebar}
                className="lg:hidden p-1.5 rounded-lg hover:bg-gray-700/50 text-gray-400 hover:text-gray-100 transition-colors duration-200"
                aria-label="Toggle sidebar"
              >
                <Bars3Icon className="w-5 h-5" />
              </button>
              <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-blue-600 shadow-blue-600/20 shadow-lg">
                <span className="font-bold text-white text-sm">A</span>
              </div>
              <div className="hidden sm:block">
                <h1 className="font-semibold text-white text-base tracking-tight">Admin Panel</h1>
              </div>
            </div>

            {/* Right: Profile */}
            <div className="flex items-center gap-4">
              <span className="hidden sm:block text-gray-400 text-sm">
                {user?.name || 'Admin'}
              </span>

              <Menu as="div" className="relative">
                <Menu.Button className="flex items-center gap-2 p-0.5 rounded-full focus:outline-none ring-2 ring-gray-700 hover:ring-gray-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 bg-gray-800 transition-all duration-200">
                  <span className="sr-only">Open user menu</span>
                  <div className="flex justify-center items-center w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-blue-700">
                    <span className="font-medium text-white text-sm">
                      {(user?.name || 'A').charAt(0).toUpperCase()}
                    </span>
                  </div>
                </Menu.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-150"
                  enterFrom="transform opacity-0 scale-95 -translate-y-1"
                  enterTo="transform opacity-100 scale-100 translate-y-0"
                  leave="transition ease-in duration-100"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="right-0 z-20 absolute w-56 mt-2.5 py-1.5 border border-gray-700 rounded-xl focus:outline-none bg-gray-800 shadow-black/20 shadow-xl origin-top-right">
                    <div className="px-4 py-3 border-gray-700 border-b">
                      <p className="font-medium text-white text-sm">{user?.name || 'Admin'}</p>
                      <p className="mt-0.5 text-gray-400 text-xs">{user?.email || 'admin@example.com'}</p>
                    </div>
                    <div className="pt-1 border-gray-700 border-t">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            type="button"
                            onClick={logoutSubmit}
                            className={classNames(
                              active ? 'bg-red-500/10 text-red-400' : 'text-gray-300',
                              'flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-150'
                            )}
                          >
                            <ArrowRightOnRectangleIcon className="w-4 h-4" />
                            Sign out
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>
      )}
    </Disclosure>
  );
}
